import type { ReactNode } from 'react'

export function SetByParent({ isSet, children }: { isSet: boolean; children: ReactNode }) {
	if (!isSet) { return children }

	return (
		<div className="grid gap-0.5">
			<div inert className="opacity-50">{children}</div>
			<p className="text-[11px] text-grey-400">Set by the parent stack (Equal sizing)</p>
		</div>
	)
}
